import store from '../../store'
import LocalStorageService from '@/services/local-storage.service'

export default async (to, from, next) => {
	if (!store.getters['auth/isAuthenticated']) {
		if (!store.getters['settings/login']) {
			await store.dispatch('settings/getLoginSettings')
		}
		LocalStorageService.set('initRoute', to.fullPath)
		return next('/auth')
	}
	return next({ meta: { layout: 'auth' } })
}